/**
 * Component: sa-product-hotspot
 * Description: 产品热点交互组件
 * Author: AI
 * Date: 2026-02-05
 */
if (!customElements.get('sa-product-hotspot')) {
  class SaProductHotspot extends HTMLElement {
    constructor() {
      super();
      // 绑定 this 指向
      this.handlePinClick = this.handlePinClick.bind(this);
      this.handleItemClick = this.handleItemClick.bind(this);
    }

    connectedCallback() {
      // 获取内部元素 (Scope Queries)
      this.pins = this.querySelectorAll('.sa-product-hotspot__pin');
      this.items = this.querySelectorAll('.sa-product-hotspot__item');

      // 绑定 Pin 事件
      if (this.pins.length > 0) {
        this.pins.forEach(pin => {
          pin.addEventListener('click', this.handlePinClick);
        });
      }

      // 绑定 List Item 事件
      if (this.items.length > 0) {
        this.items.forEach(item => {
          item.addEventListener('click', this.handleItemClick);
        });

        // 默认选中第一条，但不触发滚动
        const firstId = this.items[0].getAttribute('data-id');
        this.setActiveState(firstId, true, false);
      }
      
      console.log('SA Product Hotspot loaded:', this);
    }

    disconnectedCallback() {
      // 清理事件监听，防止内存泄漏
      if (this.pins.length > 0) {
        this.pins.forEach(pin => {
          pin.removeEventListener('click', this.handlePinClick);
        });
      }

      if (this.items.length > 0) {
        this.items.forEach(item => {
          item.removeEventListener('click', this.handleItemClick);
        });
      }
    }

    /**
     * 设置激活状态
     * @param {string} id - 热点 ID
     * @param {boolean} isActive - 是否激活
     * @param {boolean} shouldScroll - 是否触发滚动（默认 true）
     */
    setActiveState(id, isActive, shouldScroll = true) {
      if (!id) return;

      // 使用 Scope Queries 查找对应的元素
      const pin = this.querySelector(`.sa-product-hotspot__pin[data-id="${id}"]`);
      const item = this.querySelector(`.sa-product-hotspot__item[data-id="${id}"]`);

      const activePinClass = 'sa-product-hotspot__pin--active';
      const activeItemClass = 'sa-product-hotspot__item--active';

      // 点击切换逻辑：始终互斥，清除其他所有激活状态
      if (isActive) {
        this.querySelectorAll(`.${activePinClass}`).forEach(el => el.classList.remove(activePinClass));
        this.querySelectorAll(`.${activeItemClass}`).forEach(el => el.classList.remove(activeItemClass));
        
        pin?.classList.add(activePinClass);
        item?.classList.add(activeItemClass);

        // 移动端：滚动列表项到可视区域
        const isMobile = window.matchMedia('(max-width: 1023px)').matches;
        if (isMobile && item && shouldScroll) {
          item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      } else {
         pin?.classList.remove(activePinClass);
         item?.classList.remove(activeItemClass);
      }
    }

    handlePinClick(e) {
      e.preventDefault();
      e.stopPropagation(); // 防止冒泡
      const id = e.currentTarget.getAttribute('data-id');
      // 始终激活
      this.setActiveState(id, true);
    }

    handleItemClick(e) {
      const id = e.currentTarget.getAttribute('data-id');
      this.setActiveState(id, true);
    }
  }

  // 注册 Web Component
  customElements.define('sa-product-hotspot', SaProductHotspot);
}
